export function isValidABN(abn: string) {
  const abnWeights = [10, 1, 3, 5, 7, 9, 11, 13, 15, 17, 19];

  if (!/^\d{11}$/.test(abn)) return false;

  const digits = abn.split("").map(Number);
  digits[0] = digits[0] - 1; // Subtract 1 from the first digit

  const total = digits.reduce(
    (sum, digit, idx) => sum + digit * abnWeights[idx],
    0
  );
  return total % 89 === 0; // invalid if not divisible by 89 https://abr.business.gov.au/Help/AbnFormat
}
